<app-form-field [label]="label" [value]="value" [editMode]="editMode" [includeMargin]="false">
  <div class="row">
    <app-date-field class="col" [required]="required" [(ngModel)]="value"></app-date-field>
    <app-radio class="col-auto" [(ngModel)]="selectedOption" [inline]="true" [options]="allOptions" [required]="required"></app-radio>
  </div>
</app-form-field>
